import { loadSettings } from './confilmSettings.js';

export default function pageTransition(){
  // confilmの表示制御用JSON読み込み
  let settings = null;
  async function loadJson() {
    try {
      settings = await loadSettings();
    } catch (err) {
      console.error("Error initializing page:", err);
    }
  }
  loadJson();
  // 共通（settings.jsonに追加された）リンクかどうか
  const isCommonLink = (url) => {
    return settings.pageSettings.commonLinks.some((link) => link === url);
  };

  // // ドメインを取得
  const getDomain = (url) => {
    return url.hostname;
  };

  // 有効な（settings.jsonに追加された）ドメインかどうか
  const isValidDomain = (url) => {
    const domain = getDomain(new URL(url));
    if (!domain) return false;
    return settings.pageSettings.vaildDomains.some((vaildDomain) => vaildDomain === domain);
  };

  // サブドメインを取得
  const getSubdomain = (domain) => {
    const domainParts = domain.split('.');
    if (domainParts.length > 2) {
      // 最後の2つ（例: 'example.com'）を除外し、残りをサブドメインとして結合
      const subdomain = domainParts.slice(0, -2).join('.');
      return subdomain;
    }
    return undefined;
  };

  // 有効な（settings.jsonに追加された）サブドメインかどうか
  const isValidSubdomain = (url) => {
    const subdomain = getSubdomain(getDomain(new URL(url)));
    if (!subdomain) return false;
    return settings.pageSettings.vaildSubdomains.some((vaildSubDomain) => vaildSubDomain === subdomain);
  };

  // 確認ダイアログの表示が必要かどうか
  const needsConfirm = (url) => {
    return !(isCommonLink(url) || isValidSubdomain(url) || isValidDomain(url));
  };
  const isTransitionPage = (
    msg = "外部サイトに遷移します。よろしいですか？"
  ) => {
    return window.confirm(msg);
  };

  const transitionPage = (url) => { 
    if(needsConfirm(url)){
      if(isTransitionPage()) {
        window.open(url, "_blank");
      }
    }else{
      window.open(url, "_blank");
    }
  };

  return {
    transitionPage,
  };
}
